
import { defineComponent, ref, watch } from 'vue';
import { OioInput, OioButton, OioForm, OioFormItem } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'InputGroup',
  components: {
    OioInput,
    OioButton,
    OioForm,
    OioFormItem
  },
  props: ['formData'],
  setup(props) {
    const formDdata = ref({ k: '1' }); // 仅用于校验
    const keys = ref<any[]>([]);

    const onDel = (index: number) => {
      keys.value.splice(index, 1);
    };

    const onAdd = () => {
      keys.value.push({ k: '' });
    };

    const stopWatch = watch(
      () => props.formData,
      (val) => {
        if (val.valsStr) {
          keys.value = val.valsStr.split(',').map((i) => ({ k: i }));
        } else {
          keys.value.push({ k: '' });
        }
        stopWatch();
      },
      { deep: true }
    );

    watch(
      keys,
      (val) => {
        // eslint-disable-next-line vue/no-mutating-props
        props.formData.valsStr = val
          .map((i) => i.k)
          .filter((a) => !!a.trim())
          .join(',');
      },
      { deep: true }
    );

    return {
      formDdata,
      keys,
      onDel,
      onAdd
    };
  }
});
